import React               from 'react';
import PropTypes           from 'prop-types';
import { IoCloseSharp }    from 'react-icons/io5';
import { FaHeartbeat }     from 'react-icons/fa';
import './MetricDetail.scss';

export default function MetricDetail({ data, onClose }) {
  const {
    label,
    value,
    status  = 'satisfactory',  // poor | satisfactory | good
    percent = 50,              // 0-100
    date    = '05/08/2025',
    time    = '04:46 AM'
  } = data;

  /* status → colour & band width */
  const cfg = {
    poor        : { col: '#FF5A5F', band: 30 },
    satisfactory: { col: '#FFC400', band: 65 },
    good        : { col: '#35C759', band: 100 }
  }[status.toLowerCase()] || { col: '#0067ff', band: percent };

  const dash = `${percent * 2.64} 264`;   // circumference pieces

  return (
    <div className="metric-detail">
      {/* Close bar */}
      <header className="top">
        <button className="close" onClick={onClose}>
          <IoCloseSharp />
        </button>
      </header>

      {/* Content */}
      <div className="scroll-body">
        <h1 style={{ color: cfg.col }}>{label}</h1>
        <FaHeartbeat className="fav" />

        <div className="meta">
          <span>2 days ago</span>
          <span>{date} {time}</span>
        </div>

        {/* ── Summary card ───────────────────────────── */}
        <section className="summary card" style={{ '--c': cfg.col }}>
          <div className="summary__text">
            <span className="value">{value}</span>
            <span className="status">{status.toUpperCase()}</span>
          </div>

          {/* donut gauge */}
          <svg viewBox="0 0 100 100" className="gauge">
            <circle cx="50" cy="50" r="42" className="track" />
            <circle
              cx="50" cy="50" r="42"
              className="bar"
              strokeDasharray={dash}
            />
            {/* central percent text */}
            <text
              x="50" y="55"
              textAnchor="middle"
              transform="rotate(90 50 50)"
              className="pct"
            >
              {percent}
            </text>
          </svg>
        </section>

        {/* Qualitative band */}
        <section className="band card" style={{ '--c': cfg.col }}>
          <div className="labels">
            <span>Poor</span><span>Satisfactory</span><span>Good</span>
          </div>
          <div className="bar-bg">
            <div
              className="bar-fill"
              style={{ width: `${cfg.band}%` }}
            />
          </div>
        </section>

        {/* Info blocks */}
        <section className="info card">
          <h3>What is {label}?</h3>
          <p>
            Tracks your {label.toLowerCase()} and offers insights into health.
            TRUscan analyzes subtle variations to aid stress management and
            improve wellbeing.
          </p>
        </section>

        <section className="info card">
          <h3>How to improve?</h3>
          <p>
            Reduce stress (meditation, deep breathing), ensure adequate sleep,
            monitor regularly, and consult your healthcare provider if symptoms
            occur.
          </p>
        </section>

        <div style={{ height: 24 }} />
      </div>
    </div>
  );
}

MetricDetail.propTypes = {
  data: PropTypes.shape({
    label  : PropTypes.string.isRequired,
    value  : PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    status : PropTypes.string.isRequired,
    percent: PropTypes.number.isRequired,
    date   : PropTypes.string,
    time   : PropTypes.string
  }).isRequired,
  onClose: PropTypes.func.isRequired
};
